@let geConnector = connectors().GENERAL_ELECTRIC;

@if (!isGuestUser) {
  <evc-nav-button type="cta" size="xxl" variant="round" (click)="addInspection()" *callToAction data-testid="create-inspection-cta">
    <span class="top-cta-label">
      {{ callToActionLabel.label | optionalAsync }}
    </span>
    <evc-svg-icon size="md" [icon]="callToActionLabel.icon"></evc-svg-icon>
  </evc-nav-button>
}
<div class="content">
  <div class="title-container">
    <h1>{{ "topMenuBar.inspections" | translate }}</h1>
    <evc-status-indicator status="info" *ngIf="inspectionList?.total" [text]="inspectionList?.total.toString() ?? '0'" />
  </div>
  <app-inspection-list-filter [disableFilters]="isRecordsLoading" (filtersChanged)="onFilterChange($event)" (sortChanged)="onSortChange($event)" />

  <div class="table-content header-row grid-container" matSort matSortDisableClear matSortActive="inspectionDate" matSortDirection="desc">
    <div
      mat-sort-header="title"
      class="header-cell title-tile"
      (click)="onSortChange('title')"
      (mouseover)="hoveredSortType = 'title'"
      (mouseleave)="hoveredSortType = null"
    >
      <span>
        {{ "inspectionreportlist.name" | translate }}
      </span>
      <img id="no-sort-name" *ngIf="activeSort !== 'title' && hoveredSortType !== 'title'" src="assets/icons/sprite/no_sort.svg" />
    </div>
    <div class="status-tile"></div>
    <div class="header-cell serial-tile">
      {{ "settingTenant.configuration_LabelOfSerialNumber" | translate }}
    </div>
    <div
      mat-sort-header="inspectionDate"
      class="header-cell date-tile"
      (click)="onSortChange('inspectionDate')"
      (mouseover)="hoveredSortType = 'inspectionDate'"
      (mouseleave)="hoveredSortType = null"
    >
      <span>
        {{ "inspectionreportlist.date" | translate }}
      </span>
      <img id="no-sort-date" *ngIf="activeSort !== 'inspectionDate' && hoveredSortType !== 'inspectionDate'" src="assets/icons/sprite/no_sort.svg" />
    </div>
    <div class="header-cell inspector-tile">
      {{ "inspectionreportlist.inspector" | translate }}
    </div>
    <div class="header-cell images-tile">
      {{ "inspectionReport.MediaQuantity" | translate }}
    </div>
    <div class="header-cell reports-tile">
      {{ "inspectionReport.ReportsQuantity" | translate }}
    </div>
    <div class="menu-tile"></div>
  </div>
  <div
    class="table-content"
    [ngClass]="{ desktop: isDesktop }"
    infiniteScroll
    [infiniteScrollDistance]="getDynamicScrollDistance()"
    [infiniteScrollThrottle]="300"
    [scrollWindow]="false"
    [infiniteScrollDisabled]="isRecordsLoading"
    (scrolled)="onLoadNext()"
    #scrollContainer
  >
    <div
      *ngFor="let inspection of inspectionDataSource?.data; let i = index"
      class="grid-container"
      [class.inspection-disabled]="isInspectionDisabled(inspection)"
      [attr.data-testid]="'inspection-item-' + i"
      [class.user-by]="isLockedByCurrentUser(inspection)"
      [class.offline]="isOffline"
      (click)="gotoDataManagementAsNew(inspection)"
    >
      <ng-container>
        <!-- Status Tile -->
        <div class="tile status-tile">
          <div class="inspection-icon light-theme" [matTooltip]="getStatusHoverMessage(inspection)" matTooltipPosition="above">
            <img
              *ngIf="inspection.status === '000' && !isCheckoutInspection(inspection)"
              src="assets/icons/inspectionlist/statusNotStartedIcon.svg"
            />
            <img
              *ngIf="inspection.status === '000' && isCheckoutInspection(inspection)"
              src="assets/icons/inspectionlist/statusNotStartedLockedIcon.svg"
            />
            <img *ngIf="inspection.status === '500' && !isCheckoutInspection(inspection)" src="assets/icons/inspectionlist/statusEditingIcon.svg" />
            <img *ngIf="inspection.status === '500' && isCheckoutInspection(inspection)" src="assets/icons/inspectionlist/statusLockedIcon.svg" />
            <img *ngIf="inspection.status === '900' && !isCheckoutInspection(inspection)" src="assets/icons/inspectionlist/statusActiveIcon.svg" />
            <img
              *ngIf="inspection.status === '900' && isCheckoutInspection(inspection)"
              src="assets/icons/inspectionlist/statusCompletedLockedIcon.svg"
            />
          </div>

          <div class="inspection-icon dark-theme" [matTooltip]="getStatusHoverMessage(inspection)" matTooltipPosition="above">
            <img
              *ngIf="inspection.status === '000' && !isCheckoutInspection(inspection)"
              src="assets/icons/inspectionlist/dark_statusNotStartedIcon.svg"
            />
            <img
              *ngIf="inspection.status === '000' && isCheckoutInspection(inspection)"
              src="assets/icons/inspectionlist/dark_statusNotStartedLockedIcon.svg"
            />
            <img
              *ngIf="inspection.status === '500' && !isCheckoutInspection(inspection)"
              src="assets/icons/inspectionlist/dark_statusEditingIcon.svg"
            />
            <img
              *ngIf="inspection.status === '500' && isCheckoutInspection(inspection)"
              src="assets/icons/inspectionlist/dark_statusLockedIcon.svg"
            />
            <img
              *ngIf="inspection.status === '900' && !isCheckoutInspection(inspection)"
              src="assets/icons/inspectionlist/dark_statusActiveIcon.svg"
            />
            <img
              *ngIf="inspection.status === '900' && isCheckoutInspection(inspection)"
              src="assets/icons/inspectionlist/dark_statusCompletedLockedIcon.svg"
            />
          </div>
        </div>

        <!-- Title Tile -->
        <div class="tile title-tile title-text">
          <span class="title-text" [matTooltip]="inspection.title" matTooltipPosition="above">{{ inspection.title }}</span>
        </div>

        <!-- S/N Tile -->
        <div class="tile serial-tile sub-text">
          <span class="serial-text" [matTooltip]="inspection.subjectSerialNo" matTooltipPosition="above">{{ inspection.subjectSerialNo }}</span>
        </div>

        <!-- Date Tile -->
        <div class="tile date-tile sub-text">
          <span class="date-text" [matTooltip]="inspection.inspectionDate | date: 'yyyy/MM/dd'" matTooltipPosition="above">
            {{ inspection.inspectionDate | date: "yyyy/MM/dd" }}
          </span>
        </div>

        <!-- Inspector Tile -->
        <div class="tile inspector-tile sub-text" [ngClass]="{ loading: !isDspInspector(inspection.inspectorId) }">
          <ng-container *ngIf="isDspInspector(inspection.inspectorId); else elseBlock">
            <!--            <img class="img inspector" src="assets/icons/inspectionlist/user.svg">-->

            <div class="svg-icon">
              <svg width="17" height="20" viewBox="0 0 17 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4 5.20039C11.4 4.40474 11.0839 3.64168 10.5213 3.07907C9.95871 2.51646 9.19565 2.20039 8.4 2.20039C7.60435 2.20039 6.84129 2.51646 6.27868 3.07907C5.71607 3.64168 5.4 4.40474 5.4 5.20039C5.4 5.99604 5.71607 6.7591 6.27868 7.32171C6.84129 7.88432 7.60435 8.20039 8.4 8.20039C9.19565 8.20039 9.95871 7.88432 10.5213 7.32171C11.0839 6.7591 11.4 5.99604 11.4 5.20039ZM3.6 5.20039C3.6 3.92735 4.10571 2.70645 5.00589 1.80628C5.90606 0.906104 7.12696 0.400391 8.4 0.400391C9.67304 0.400391 10.8939 0.906104 11.7941 1.80628C12.6943 2.70645 13.2 3.92735 13.2 5.20039C13.2 6.47343 12.6943 7.69433 11.7941 8.5945C10.8939 9.49468 9.67304 10.0004 8.4 10.0004C7.12696 10.0004 5.90606 9.49468 5.00589 8.5945C4.10571 7.69433 3.6 6.47343 3.6 5.20039ZM1.84875 17.8004H14.9512C14.6175 15.4266 12.5775 13.6004 10.1137 13.6004H6.68625C4.2225 13.6004 2.1825 15.4266 1.84875 17.8004ZM0 18.4866C0 14.7929 2.9925 11.8004 6.68625 11.8004H10.1137C13.8075 11.8004 16.8 14.7929 16.8 18.4866C16.8 19.1016 16.3012 19.6004 15.6862 19.6004H1.11375C0.49875 19.6004 0 19.1016 0 18.4866Z"
                  fill="currentColor"
                />
              </svg>
            </div>

            <span class="inspector-text" [matTooltip]="inspection.inspectorId | userNamePipe: tenantUsers" matTooltipPosition="above">
              {{ inspection.inspectorId | userNamePipe: tenantUsers }}
            </span>
          </ng-container>
          <ng-template #elseBlock>
            <img alt="image loading" class="loading-image" src="assets/images/loading.gif" />
          </ng-template>
        </div>

        <!-- Images Tile -->
        <div class="tile images-tile sub-text">
          <ng-container *ngIf="inspection.imageCount !== undefined || imageCountPerInspection?.[inspection.id] !== undefined; else elseBlock">
            <!-- <img class="img images file" src="assets/icons/inspectionlist/image.svg">-->
            <!-- inline svg to have dynamic css -->
            <div class="svg-icon">
              <svg width="18" height="22" viewBox="0 0 18 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.66602 19.9375C3.25352 19.9375 2.91602 19.6281 2.91602 19.25V2.75C2.91602 2.37188 3.25352 2.0625 3.66602 2.0625H11.166V5.5C11.166 6.26055 11.8363 6.875 12.666 6.875H16.416V19.25C16.416 19.6281 16.0785 19.9375 15.666 19.9375H3.66602ZM3.66602 0C2.01133 0 0.666016 1.2332 0.666016 2.75V19.25C0.666016 20.7668 2.01133 22 3.66602 22H15.666C17.3207 22 18.666 20.7668 18.666 19.25V6.63867C18.666 5.9082 18.352 5.20781 17.7895 4.69219L13.5426 0.803516C12.9801 0.287891 12.2207 0 11.4238 0H3.66602ZM8.16602 11C8.16602 10.6353 8.00798 10.2856 7.72668 10.0277C7.44537 9.76987 7.06384 9.625 6.66602 9.625C6.26819 9.625 5.88666 9.76987 5.60536 10.0277C5.32405 10.2856 5.16602 10.6353 5.16602 11C5.16602 11.3647 5.32405 11.7144 5.60536 11.9723C5.88666 12.2301 6.26819 12.375 6.66602 12.375C7.06384 12.375 7.44537 12.2301 7.72668 11.9723C8.00798 11.7144 8.16602 11.3647 8.16602 11ZM11.4098 13.0152C11.2691 12.8305 11.0395 12.7188 10.791 12.7188C10.5426 12.7188 10.3129 12.8305 10.1723 13.0152L8.23633 15.5805L7.67852 14.7598C7.54258 14.5578 7.29883 14.4375 7.04102 14.4375C6.7832 14.4375 6.54414 14.5578 6.40352 14.7598L4.52852 17.5098C4.3832 17.7203 4.37852 17.9867 4.50977 18.2059C4.64102 18.425 4.89414 18.5582 5.16602 18.5582H7.41602H8.91602H10.791H14.166C14.4473 18.5582 14.7004 18.4164 14.8316 18.1887C14.9629 17.9609 14.9441 17.6902 14.7848 17.4797L11.4098 13.0109V13.0152Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <span class="images-text">{{ inspection.imageCount ?? imageCountPerInspection?.[inspection.id] ?? 0 }}</span>
          </ng-container>
          <ng-template #elseBlock>
            <img alt="image loading" class="loading-image" src="assets/images/loading.gif" />
          </ng-template>
        </div>

        <!-- Reports Tile -->
        <div
          class="tile reports-tile sub-text"
          [ngClass]="{ 'button-Hovering': isHover(inspection.id) }"
          (mouseover)="hoverIn(inspection)"
          (mouseout)="hoverOut()"
        >
          <ng-container>
            <!--              <img class="img reports" src="assets/icons/inspectionlist/report.svg">-->
            <!-- inline svg to have dynamic css -->
            <div class="svg-icon">
              <svg width="17" height="22" viewBox="0 0 17 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.6673 2.75H12.0007H11.6007C11.2923 1.18164 9.94648 0 8.33398 0C6.72148 0 5.37565 1.18164 5.06732 2.75H4.66732H3.00065C1.52982 2.75 0.333984 3.9832 0.333984 5.5V19.25C0.333984 20.7668 1.52982 22 3.00065 22H13.6673C15.1382 22 16.334 20.7668 16.334 19.25V5.5C16.334 3.9832 15.1382 2.75 13.6673 2.75ZM3.66732 4.8125V5.84375C3.66732 6.41523 4.11315 6.875 4.66732 6.875H8.33398H12.0007C12.5548 6.875 13.0007 6.41523 13.0007 5.84375V4.8125H13.6673C14.034 4.8125 14.334 5.12187 14.334 5.5V19.25C14.334 19.6281 14.034 19.9375 13.6673 19.9375H3.00065C2.63398 19.9375 2.33398 19.6281 2.33398 19.25V5.5C2.33398 5.12187 2.63398 4.8125 3.00065 4.8125H3.66732ZM7.33398 3.4375C7.33398 3.164 7.43934 2.90169 7.62688 2.7083C7.81441 2.5149 8.06877 2.40625 8.33398 2.40625C8.5992 2.40625 8.85356 2.5149 9.04109 2.7083C9.22863 2.90169 9.33398 3.164 9.33398 3.4375C9.33398 3.711 9.22863 3.97331 9.04109 4.1667C8.85356 4.3601 8.5992 4.46875 8.33398 4.46875C8.06877 4.46875 7.81441 4.3601 7.62688 4.1667C7.43934 3.97331 7.33398 3.711 7.33398 3.4375ZM12.3757 11.4984C12.7673 11.0945 12.7673 10.4414 12.3757 10.0418C11.984 9.64219 11.3507 9.63789 10.9632 10.0418L7.22565 13.8961L5.70898 12.332C5.31732 11.9281 4.68398 11.9281 4.29648 12.332C3.90898 12.7359 3.90482 13.3891 4.29648 13.7887L6.51732 16.0789C6.70482 16.2723 6.95898 16.3797 7.22565 16.3797C7.49232 16.3797 7.74648 16.2723 7.93398 16.0789L12.3757 11.4984Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <span class="images-text">{{ inspection.reportCount }}</span>
          </ng-container>
        </div>

        <!-- Menu Tile -->
        <div class="tile menu-tile">
          @if (canShowOptionsMenu(inspection)) {
            <button mat-icon-button [matMenuTriggerFor]="MatMenu" (click)="$event.stopPropagation()" data-testid="inspection-options-menu">
              <mat-icon class="open-list-item-menu">more_vert</mat-icon>
            </button>
          }
          <mat-menu #MatMenu>
            @if (geConnector?.isEnabled && isGeConnectorFeatureFlagEnabled()) {
              <button mat-menu-item (click)="toggleInspectionSharing(inspection, geConnector.connectorId)">
                <mat-checkbox [checked]="inspection.connectorTenantId === geConnector.connectorId">
                  <span class="context-menu-item">{{ "inspectionSharing.shareWithGeneralElectric" | translate }}</span>
                </mat-checkbox>
              </button>
            }

            <button mat-menu-item *ngIf="isDesktopAndOnline && !inspection.sharedLockBy" (click)="toggleInspectionCheckout(inspection.id)">
              <span class="context-menu-item">{{ "inspectionlist.checkOut" | translate }}</span>
            </button>

            <button mat-menu-item *ngIf="isDesktopAndOnline && isLockedByCurrentUser(inspection)" (click)="toggleInspectionCheckout(inspection.id)">
              <span class="context-menu-item">{{ "inspectionlist.cancelCheckOut" | translate }}</span>
            </button>

            <button mat-menu-item (click)="deleteInspection(inspection)" [disabled]="!isOffline && inspection.sharedLockBy">
              <span class="context-menu-item">{{ "inspectionlist.delete" | translate }}</span>
            </button>
          </mat-menu>
        </div>
      </ng-container>
    </div>

    <div class="record-loading-area">
      <img
        *ngIf="inspectionFound && this.inspectionList?.items.length < this.inspectionList?.total"
        class="loading"
        src="assets/images/loading.gif"
        alt=""
      />
      <div *ngIf="!inspectionFound && !isRecordsLoading" class="no-inspection-found" fxLayout="row" fxLayoutAlign="center none">
        {{ "inspectionlist.noinspectionFound" | translate }}
      </div>
    </div>
  </div>
</div>
